import { Instance, SnapshotOut, types } from 'mobx-state-tree';

/**
 * # Nks
 *
 * Nks을 설명하세요.
 */
export const Nks = types
  .model('Nks')
  // --------------------------------------------------------------------------
  .props({
    clstrSid: types.identifierNumber,
    clstrNm: types.optional(types.string, ''), // 클러스터 이름
    nodeCnt: types.maybeNull(types.optional(types.number, 0)), // 노드 수
    k8sVersion: types.maybeNull(types.string), // k8s version
    k8sConfigInfo: types.maybeNull(types.string), // kubeconfig 파일
    k8sConfigPath: types.maybeNull(types.string), // kubeconfig 경로

    useYn: types.maybeNull(types.optional(types.string, 'Y')),
    delYn: types.maybeNull(types.optional(types.string, 'N')),

    insertDt: types.optional(types.number, 0),
    updateDt: types.optional(types.number, 0),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model nks --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: INks }) => {
      const newProps = { ...self, ...props } as INks;
      (Object.keys(newProps) as TNksKeys[]).forEach((key) => {
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TNks = Instance<typeof Nks>;
type TNksSnapshot = SnapshotOut<typeof Nks>;

export interface INks extends TNks {}
export type TNksKeys = keyof TNksSnapshot & string;
export interface INksSnapshot extends TNksSnapshot {}
export const createNks = () => types.optional(Nks, {} as TNks);
